import styled from "styled-components";

export const Spacer = styled.div`
	width: 100%;
	margin-top: ${(p) => (p.rows ? `${p.rows * 1.6}rem` : `${p.size}px`)};
`;
